<div class="pill-button-list">
  <mat-chip-list aria-label="pill buttons" [ngClass]="getColumns()">
    <ng-container *ngFor="let pill of pillButtonDTOList">
      <app-pill-button
        [pillButtonDTO]="pill"
        [gradingLink]="gradingLink"
        [hasEdit]="hasEdit"
        [classroom]="classroom"
        (selectedChanged)="onSelectedChanged($event)"
        (editClicked)="onEditClicked($event)"
      ></app-pill-button>
    </ng-container>
  </mat-chip-list>
</div>
